import { memo, useContext, useMemo } from 'react';
import { Position } from '@xyflow/react';
import { getLiteral } from 'utils/getLiteral';

import {
    findNodeByType,
    getAutomationEntityByValue,
    resolveAutomationEntityIcon,
    resolveAutomationTriggerIcon,
} from '../../../utils';
import { AutomationBuilderCanvasContext } from '../AutomationBuilderCanvasContext';
import AutomationBuilderBox from '../components/AutomationBuilderBox';
import AutomationBuilderReEntryRow from '../components/AutomationBuilderReEntryRow';
import AutomationCanvasHandle from '../components/AutomationCanvasHandle';

const AutomationBuilderTriggerBox = memo((props) => {
    const { data, persistEveryTime } = useContext(AutomationBuilderCanvasContext);
    const nodeData = useMemo(() => findNodeByType(data?.scene, props.id), [data?.scene, props.id]);
    const everyTime = nodeData?.parameters?.everyTime ?? props.data?.everyTime ?? false;
    const textValue = useMemo(() => {
        const entity = getAutomationEntityByValue(nodeData?.parameters?.entity?.value);

        if (!entity || !nodeData?.parameters?.action) return;
        let text = `${getLiteral(entity?.labels?.singular)} ${getLiteral(nodeData?.parameters?.action?.title)}`;
        if (nodeData?.parameters?.withCreation)
            text += ` (${getLiteral('label_automation_event_creation_included')})`;
        return text;
    }, [nodeData]);

    const reEntryFooter = useMemo(
        () => (
            <AutomationBuilderReEntryRow
                checked={everyTime}
                interactive
                onChange={persistEveryTime}
            />
        ),
        [everyTime, persistEveryTime],
    );

    return (
        <>
            <AutomationBuilderBox
                {...props}
                className="fm-automation-builder__trigger-box"
                title={getLiteral('label_trigger')}
                icon={resolveAutomationEntityIcon(
                    nodeData?.parameters?.entity
                        ? nodeData?.parameters?.entity?.value
                        : 'arrowDropRightRaw',
                )}
                secondIcon={resolveAutomationTriggerIcon(
                    nodeData?.parameters?.action?.icon,
                    nodeData?.parameters?.action?.value,
                )}
                textValue={textValue}
                emptyPlaceholder={getLiteral('action_automation_add_trigger')}
                footer={reEntryFooter}
                isIncomplete={nodeData?._isIncomplete}
            ></AutomationBuilderBox>
            <AutomationCanvasHandle
                className="fm-automation-builder__handler-trigger"
                type="source"
                position={Position.Bottom}
                id="bottom"
                boxId={props.id}
                isConnectable={false}
                isIncomplete={nodeData?._isIncomplete}
            />
        </>
    );
});

AutomationBuilderTriggerBox.displayName = 'AutomationBuilderTriggerBox';

export default AutomationBuilderTriggerBox;
